import React from 'react';
import { Box, Divider } from '@mui/material';
import CeoReportingDashboard from './CeoReportingDashboard';
import Dashboard from './Dashboard';

/**
 * Single modular dashboard: CEO/Salesforce widgets + BDM operational widgets.
 * Visibility per widget is controlled by role permissions (User Management).
 * Date range comes from the global selectors in the sidebar header.
 */
export default function UnifiedDashboard() {
  return (
    <Box sx={{ pb: 4 }}>
      <CeoReportingDashboard unified />
      <Divider sx={{ my: 4 }} />
      <Dashboard unified />
    </Box>
  );
}
